import { useRequest } from "@/shared/composables/useRequest.ts";
import { HttpClientService } from "@/shared/services/http_client/HttpClientService.ts";
import { SystemRepository } from "@/app/system/repositories/SystemRepository";
import { SystemModel } from "@/app/system/models/SystemModel";

export function getSystemInfoController() {
  const repository: SystemRepository = new SystemRepository(new HttpClientService());

  return useRequest<SystemModel>({
    fn: async () => await repository.getSystemInfo(),
    modelClass: SystemModel,
  });
}
